import moment from "moment";

export const maxEndDate = (startDate: moment.Moment) =>
  startDate ? moment(startDate).endOf("month") : moment().endOf("month");
